<table class="table filtrable-table">
  <thead>
    <ng-container *ngTemplateOutlet="headTpl"></ng-container>
  </thead>
  <tbody>
    <ng-container *ngFor="let row of filteredRows">
      <ng-container *ngTemplateOutlet="bodyTpl; context: {$implicit: row}"></ng-container>
    </ng-container>
  </tbody>
</table>